import CustomConfig from 'models/CustomConfig';
import { ReactNode, useContext, useState } from 'react';
import { getCurrentProduct, updateCookieCurrentProduct } from 'utils/productCookies';
import { MenuContext, MenuContextData } from './MenuContextData';
import { deleteCurrentCompanyIdCookie, updateCurrentCompanyIdCookie, updateCurrentIdentifierCookie } from 'utils/identifier';
import CurrentCompany from 'models/Profile/CurrentCompany';
import useFetchMenu from 'hooks/useFetchMenu';
import useFetchCompanies from 'hooks/useFetchCompany';
import getBreadcrumbBasedOnUrl from 'utils/breadcrumb';
import Breadcrumb from 'models/Breadcrumb';
import CompanyId from 'models/Profile/CompanyId';
import { redirectFavoriteProduct } from 'utils/constants';

type MenuContextProviderProps = {
  children: ReactNode;
}

export function MenuContextProvider({ children }: MenuContextProviderProps) : JSX.Element {
  const [openedMenu, setOpenedMenu] = useState(getCurrentProduct());
  const [customConfig, setCustomConfig] = useState({} as CustomConfig);

  const { menu, fetchMenu } = useFetchMenu();
  const { companies, fetchCompanies } = useFetchCompanies();

  const isUndefined = () : boolean => {
    if (menu.applications === null) return true;
    if (menu.applications === undefined) return true;
    return Object.keys(menu.applications).length === 0;
  };

  const updateOpenedMenu = (productName : string) : void => {
    setOpenedMenu(productName);
  };

  const getBreadcrumb = () : Breadcrumb => {

    if(isUndefined())
      return { noun : getCurrentProduct() } as Breadcrumb;

    const history = getBreadcrumbBasedOnUrl(menu, window.location.href);
    updateCookieCurrentProduct(history.noun);

    return {
      noun : history.noun || getCurrentProduct(),
      breadcrumb : history.breadcrumb
    };
  };

  const updateCurrentCompany = (company : CurrentCompany) : void => {
    updateCurrentIdentifierCookie(company.identifier);
    updateCompanyId(company);
    redirectFavoriteProduct();
  };

  const updateCompanyId = (company : CurrentCompany) : void => {
    const currentCompany = !company.companyId ? {} as CompanyId : company.companyId[0];

    if(Object.keys(currentCompany).length === 0) {
      deleteCurrentCompanyIdCookie();
      return;
    }

    updateCurrentCompanyIdCookie(currentCompany.id);
  };

  return (
    <MenuContext.Provider
      value={{
        menu,
        companies,
        customConfig,
        openedMenu,
        isUndefined,
        setCustomConfig,
        getBreadcrumb,
        updateCurrentCompany,
        updateOpenedMenu,
        fetchCompanies,
        fetchMenu
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}

export const useMenu = () : MenuContextData => {
  return useContext(MenuContext);
};